// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 179) return "bundle.500f679716fbcabec76aa12d9afa8f79.css";
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "a27a4871cc28ab50639dd1f4653eeb7c" + ".css";
};